<div class="main-panel">
  <!-- BEGIN : Main Content-->
  <div class="main-panel">
    <!-- BEGIN : Main Content-->
    <div class="main-content">
      <div class="content-wrapper">
        <div>
          <section id="scroll-dynamic">
            <div class="row">
              <div class="col-12">
                <div class="card border">
                  <div class="card-header">

                    <h4 class="form-section"><i class="ft-user"></i> Import Users</h4>
                    <hr>
                    <br>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row">
                          <div class="col-md-1" >
                            <h5 class=" form-section " for="userinput5">Device : </h5>
                          </div>
                          <div class="col-md-3">
                            <select id="userinput5" (change)="selectChangeHandlerDeviceFrom($event)"
                              class="browser-default custom-select">
                              <option selected>Select Device</option>
                              <option *ngFor="let item of Device" value="{{item.device_id}}">{{item.deviceName}}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-3">

                            <input type="file" style="border: 1px solid #ced4da; padding: 2%;" id="file"
                              (change)="handleFileInput($event.target.files)">
                          </div>
                          <div class="col-md-3">
                            <input type="button" class="btn btn-primary" value="submit"
                              (click)="uploadFileToActivity()">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div *ngIf="!dataTable" class="row ">

              <div class="col-12">
                <br>
                    <br>
                    <br>
                    <br>
                <div class="card border ">
                  <div class="card-header">


                    <div class="row">
                      <div class="col-md-12">
                        <h4 class="form-section"><i class="ft-user"></i> Excel File Template</h4>
                        <table class="table">


                          <thead>
                            <tr>
                              <th> User ID</th>
                              <th> User Name</th>

                            </tr>


                          </thead>
                          <tbody>
                            <tr>
                              <td>1005</td>
                              <td>John Max</td>
                            </tr>
                            <tr>
                              <td>1006</td>
                              <td>Peter </td>
                            </tr>
                            <tr>
                              <td>1007</td>
                              <td>Julie</td>
                            </tr>
                            <tr>
                              <td>1008</td>
                              <td>Maria Adams</td>
                            </tr>
                            <tr>
                              <td>1009</td>
                              <td>Ava Ann</td>
                            </tr>
                            <tr>
                              <td>1010</td>
                              <td>John Wick</td>
                            </tr>

                          </tbody>
                        </table>



                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div *ngIf="dataTable" class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header">


                    <div class="row">
                      <div class="col-md-12">
                        <h4 class="form-section"><i class="ft-user"></i> Uploading Summary</h4>
                        <table class="table">


                          <thead>
                            <tr>
                              <th> Total Users</th>
                              <th> Accept Employee</th>
                              <th> Rejected Employee</th>
                            </tr>


                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ExcelUploadResponse.total}}</td>
                              <td>{{ExcelUploadResponse.accepted}}</td>
                              <td>{{ExcelUploadResponse.rejected}}</td>
                            </tr>
                          </tbody>
                        </table>



                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div *ngIf="dataTable" class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header">


                    <div class="row">
                      <div class="col-md-12">
                        <h4 class="form-section"><i class="ft-user"></i> Rejeected Users</h4>
                        <table datatable class="table table-responsive-sm text-center">
                          <thead>
                            <tr>
                              <th> UserID</th>
                              <th> User Name</th>
                              <th> Reason</th>
                            </tr>


                          </thead>
                          <tbody>
                            <tr *ngFor="let item of ExcelUploadResponse.rejectedUsersList">
                              <td>{{item.userID}}</td>
                              <td>{{item.username}}</td>
                              <td>{{item.status}}</td>

                            </tr>
                          </tbody>
                        </table>



                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <h3 style="color: white">Please Wait ... </h3>
    </ngx-spinner>













